import { useState } from "react";

import Input from "../../ui/input/Input";
import Button from "../../ui/button/Button";
import Alert from "../../ui/alert/Alert";

import "./MfaLoginForm.css";

export default function MfaLoginForm({ onSubmit, isLoading, error }) {
  const [code, setCode] = useState("");

  const cleanCode = code.replace(/\D/g, "");

  const canSubmit = cleanCode.length === 6 && !isLoading;

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);

    setCode(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) return;

    onSubmit(cleanCode);
  };

  return (
    <form className="mfa-login-form" onSubmit={handleSubmit}>
      <Alert type="info">
        Vul de 6-cijferige code uit je authenticator-app in.
      </Alert>

      {error && <Alert type="error">{error}</Alert>}

      <Input
        id="mfaCode"
        label="MFA-code"
        value={code}
        onChange={handleChange}
        placeholder="123456"
        inputMode="numeric"
        maxLength={6}
        autoComplete="one-time-code"
        disabled={isLoading}
      />

      <Button type="submit" disabled={!canSubmit}>
        {isLoading ? "Controleren..." : "Verifiëren"}
      </Button>
    </form>
  );
}
